/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation } from "@tanstack/react-query";
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    InsertablePersonalAccessToken,
    PersonalAccessTokenId,
    PersonalAccessTokenWithSecretDto,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const deletePersonalAccessTokensTokenId = (
    tokenId: PersonalAccessTokenId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/personal-access-tokens/${tokenId}`, options);
};

export const getDeletePersonalAccessTokensTokenIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deletePersonalAccessTokensTokenId>>,
        TError,
        { tokenId: PersonalAccessTokenId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deletePersonalAccessTokensTokenId>>,
    TError,
    { tokenId: PersonalAccessTokenId },
    TContext
> => {
    const mutationKey = ["deletePersonalAccessTokensTokenId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deletePersonalAccessTokensTokenId>>,
        { tokenId: PersonalAccessTokenId }
    > = (props) => {
        const { tokenId } = props ?? {};

        return deletePersonalAccessTokensTokenId(tokenId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeletePersonalAccessTokensTokenIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deletePersonalAccessTokensTokenId>>
>;

export type DeletePersonalAccessTokensTokenIdMutationError =
    AxiosError<unknown>;

export const useDeletePersonalAccessTokensTokenId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deletePersonalAccessTokensTokenId>>,
            TError,
            { tokenId: PersonalAccessTokenId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deletePersonalAccessTokensTokenId>>,
    TError,
    { tokenId: PersonalAccessTokenId },
    TContext
> => {
    return useMutation(
        getDeletePersonalAccessTokensTokenIdMutationOptions(options),
        queryClient
    );
};
export const postPersonalAccessTokens = (
    insertablePersonalAccessToken: InsertablePersonalAccessToken,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PersonalAccessTokenWithSecretDto>> => {
    return axios.post(
        `/api/personal-access-tokens`,
        insertablePersonalAccessToken,
        options
    );
};

export const getPostPersonalAccessTokensMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postPersonalAccessTokens>>,
        TError,
        { data: InsertablePersonalAccessToken },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postPersonalAccessTokens>>,
    TError,
    { data: InsertablePersonalAccessToken },
    TContext
> => {
    const mutationKey = ["postPersonalAccessTokens"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postPersonalAccessTokens>>,
        { data: InsertablePersonalAccessToken }
    > = (props) => {
        const { data } = props ?? {};

        return postPersonalAccessTokens(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostPersonalAccessTokensMutationResult = NonNullable<
    Awaited<ReturnType<typeof postPersonalAccessTokens>>
>;
export type PostPersonalAccessTokensMutationBody =
    InsertablePersonalAccessToken;
export type PostPersonalAccessTokensMutationError = AxiosError<unknown>;

export const usePostPersonalAccessTokens = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postPersonalAccessTokens>>,
            TError,
            { data: InsertablePersonalAccessToken },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postPersonalAccessTokens>>,
    TError,
    { data: InsertablePersonalAccessToken },
    TContext
> => {
    return useMutation(
        getPostPersonalAccessTokensMutationOptions(options),
        queryClient
    );
};
